/* @flow */
import { CONSENT_CHARGE_AMOUNT } from 'constants/ParentalConsentConstants';
import PropTypes from 'prop-types';
import * as React from 'react';
import BoxSelect from 'components/BoxSelect';
import BoxSelectItem from 'components/BoxSelectItem';
import Button from 'components/ButtonDeprecated';
import Container from 'components/Container';
import Row from 'components/Row';
import Text from 'components/Text';
import TitleHeader from 'components/TitleHeader';

class ParentalConsentOptionsView extends React.Component<{
  childName?: string,
  onProceed: Function,
  setOption: Function,
}> {
  static propTypes = {
    childName: PropTypes.string,
    onProceed: PropTypes.func.isRequired,
    setOption: PropTypes.func.isRequired,
  };

  handleOptionSelect = (option: string) => {
    this.props.setOption(option);
  };

  handleSkip = () => {
    this.props.onProceed();
  };

  render() {
    const { childName } = this.props;

    return (
      <div className="ParentalConsentOptionsView">
        <Container size="medium">
          <TitleHeader
            title={`${childName || 'Your child'} signed up for Remind.`}
            subtext={`
              As part of federal law, we need to confirm that
              ${childName || 'your child'}
              has your permission to use Remind. If
              ${childName || 'your child'}
              doesn’t have permission from a parent or guardian to use Remind, their account will be deleted.
            `}
          />
          <Row size="small">
            <BoxSelect>
              <BoxSelectItem
                glyph="credit-card"
                label="Use a card"
                className="ParentalConsentOptionsView-option--card"
                eventElementName="ParentalConsentOptionsView-option--card"
                action={() => this.handleOptionSelect('card')}>
                Verify your identity with a temporary charge of {CONSENT_CHARGE_AMOUNT} to your
                card.
              </BoxSelectItem>
              <BoxSelectItem
                glyph="printer"
                label="Sign a permission form"
                action={() => this.handleOptionSelect('signature-file')}
                className="ParentalConsentOptionsView-option--signature-file"
                eventElementName="ParentalConsentOptionsView-option--signature-file">
                Download and sign a permission form, then upload it to Remind.
              </BoxSelectItem>
            </BoxSelect>
          </Row>
          <Text align="center" element="div">
            <Button
              color="graphite"
              level="text"
              data-test="parental-consent-options-view-skip"
              onClick={() => this.handleSkip()}>
              <Text size="xsmall">Skip for now</Text>
            </Button>
          </Text>
        </Container>
      </div>
    );
  }
}

export default ParentalConsentOptionsView;
